module.exports = __webpack_public_path__ + "img/media2.f2657e15.jpeg";